











































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Selector extends Vue {
  @Prop({ required: false })
  public value!: any;

  @Prop({ default: null })
  public nativeValuePath!: string;

  @Prop({ default: "" })
  public vid!: string;

  @Prop({ default: "" })
  public rules!: string;

  @Prop({ required: true })
  public items!: object[];

  @Prop({ required: false, default: false })
  public multiselect!: boolean;

  @Prop({ required: false, default: null })
  public name!: string;

  @Prop({ required: false, default: null })
  public type!: string;

  @Prop({ default: false })
  private disabled!: boolean;

  @Prop({ default: false })
  public withoutBorder!: boolean;

  @Prop({ default: () => () => false })
  private itemDisabledFunc!: Function;

  @Prop({ default: true })
  private separateWithLines!: boolean;

  @Prop({ default: true })
  private allowUnselect!: boolean;

  public onClick(item) {
    if (this.disabled) return;
    if (this.itemDisabledFunc(item)) return;
    const newItem = this.prepareValue(this.getValue(item));
    if (!this.allowUnselect && this.$_.isNil(newItem)) return;
    this.$emit("input", newItem);
  }

  public getValue(item) {
    return this.nativeValuePath
      ? this.$_.get(item, this.nativeValuePath)
      : item;
  }

  public isSelected(item) {
    return !!(this.multiselect
      ? (this.value || []).includes(this.getValue(item))
      : this.value === this.getValue(item));
  }

  public prepareValue(value) {
    if (this.multiselect) {
      const arr = this.value || [];
      return arr.includes(value)
        ? this.$_.without(arr, value)
        : this.$_.union(arr, [value]);
    }
    return this.value === value ? null : value;
  }
}
